export enum MessageType
{
    Text = 1,
    File = 2,
    Image = 3,
    Audio = 4
}
